module.exports = __webpack_public_path__ + "img/messagebird.32cae951.svg";